import Isotope from 'isotope-layout';
class detail {
	constructor(config) {
		this.config = Object.assign({
			scope: '.grid'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.initMasonry();
	}

	initMasonry(){
		let isotope = new Isotope(this.$scope[0],{
			itemSelector: '.grid-item',
			isotope: {horizontalOrder: true}
		});

		let timeout = null;
		timeout ? clearTimeout(timeout) : null;
		let observer = new ResizeObserver(() => {
			timeout = setTimeout(() => {
				isotope.layout();
			}, 50)
		});
		this.$scope.find('.grid-item').each((index, element) => observer.observe(element))
	}
}

export default new detail;